
















import { CreateElement, VNode } from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwSpinningProgress } from '../sw-progress';
import SwTable from './sw-table.vue'; // only for types
import { SwIcon } from '../sw-icon';
import {
  TableColumnConfig,
  TableEntry,
  TableEntryExpandingEventData,
  PaginationConfig,
} from './types';

const cssPrefix = 'sw-table-expand-row';
const i18nPathPrefix = 'libShared.SwTable';

@Component({
  components: {
    SwIcon,
    SwSpinningProgress,
  },
})
export default class SwTableExpandRow extends SwExtendedVue {
  @Prop({ type: String, required: true })
  instanceId: string;

  @Prop({ type: Array, required: true })
  columnsConfig: TableColumnConfig[];

  @Prop({ type: Array, required: true })
  effectiveColumnsConfig: TableColumnConfig[];

  @Prop({ type: Object })
  effectivePaginationConfig: PaginationConfig | null;

  @Prop({ type: Object, required: true })
  entry: TableEntry;

  @Prop({ type: Number, required: true })
  index: number;

  @Prop({ type: Boolean, required: true })
  accordion: boolean;

  @Prop({ type: String, required: true })
  size: SwTable['size'];

  @Prop({ type: Boolean, required: true })
  stripe: boolean;

  @Prop({ type: Boolean, required: true })
  border: boolean;

  @Prop({ type: Number, required: true })
  nestLevel: number;

  @Prop({ type: Number, required: true })
  indentSize: number;

  @Prop({ type: Boolean, required: true })
  clickRowToExpand: boolean;

  @Prop({ type: Boolean, required: true })
  clickRowToSelect: boolean;

  cssPrefix = cssPrefix;
  i18nPathPrefix = i18nPathPrefix;

  get expandColConfig() {
    return this.effectiveColumnsConfig.find(col => col.type === 'expand');
  }

  @Inject()
  claimNestedEntryExpanded: SwTable['claimNestedEntryExpanded'];

  onNestedEntryExpanding(params: TableEntryExpandingEventData) {
    this.claimNestedEntryExpanded(params);
  }

  beforeCreate() {
    this.$options.components!.SwTable = require('./sw-table.vue').default;
  }

  /* tslint:disable-next-line */
  render(h: CreateElement): VNode {
    const contentNodes: JSX.Element[] = [];

    const loadingNode = (
      <div class={[`${this.cssPrefix}__loading-cont`, 'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify']}>
        <sw-spinning-progress size={'20px'} />
        <span style={{ marginLeft: '10px' }}>{ this.$t(`${i18nPathPrefix}.loading`) }</span>
      </div>
    );

    if (this.expandColConfig) {
      /** regular expandable row, the render function must exist */
      let contentNode: JSX.Element | null = null;
      if (this.entry._toLoadChildren === true) {
        /** we are doing lazy loading for this entry now */
        contentNode = loadingNode;
      } else {
        contentNode = this.expandColConfig.render!.call(this, this.$createElement, {
          entry: this.entry,
          index: this.index,
        });
      }
      contentNodes.push(contentNode!);
    } else if (Array.isArray(this.entry._children)) {
      /** expandable row for tree table, so we will be composing the sw-table for next tree level in this expandable row */
      const nestedPaginationConfig = this.effectivePaginationConfig && this.effectivePaginationConfig.nestedPagination ?
        Object.assign({}, this.effectivePaginationConfig.nestedPagination) : null;
      let tableNode = null;

      if (this.entry._toLoadChildren === true) {
        /** we are doing lazy loading for this children rows now */
        tableNode = loadingNode;
      } else {
        // if (nestedPaginationConfig) {
        //   nestedPaginationConfig.total = (this.entry._childTotal !== undefined) ? this.entry._childTotal : this.entry._children.length;
        // }
        tableNode = (
          <sw-table
            columnsConfig={this.columnsConfig}
            tableData={this.entry._children}
            accordion={this.accordion}
            size={this.size}
            stripe={this.stripe}
            border={this.border}
            showHeader={false}
            nestLevel={this.nestLevel + 1}
            indentSize={this.indentSize}
            pagination={nestedPaginationConfig}
            onEntryExpanding={this.onNestedEntryExpanding}
          ></sw-table>
        );
      }

      contentNodes.push(tableNode);
    }

    const rootNode = (
      <div class={[`${this.cssPrefix}`, `${this.cssPrefix}--${this.instanceId}`]}>
        <div class={[`${this.cssPrefix}__cont-wrapper`]}>
          {contentNodes}
        </div>
      </div>
    );

    return rootNode as VNode;
  }
}
